<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="grid list-demo">
    <div class="col-12">
        <p-card>
            <h5>Administration - Tâches planifiées</h5>

            @if (loading()) {
                <p-skeleton styleClass="mb-2"></p-skeleton>
                <p-skeleton styleClass="mb-2"></p-skeleton>
                <p-skeleton styleClass="mb-2"></p-skeleton>
            }

            @if (errorMessage && !loading()) {
                <div class="p-message p-message-error">
                    <div class="p-message-wrapper flex gap-2">
                        <span class="p-message-icon pi pi-times-circle"></span>
                        <div class="p-message-text">
                            <span class="p-message-summary">Erreur</span>
                            <span class="p-message-detail">{{ errorMessage }}</span>
                        </div>
                    </div>
                </div>
                <div class="mt-3">
                    <p-button icon="pi pi-refresh" label="Recharger" [outlined]="true" (onClick)="ngOnInit()"></p-button>
                </div>
            }

            @if (!loading() && !errorMessage) {
                <div class="p-message p-message-warn mb-3">
                    <div class="p-message-wrapper flex gap-2">
                        <span class="p-message-icon pi pi-exclamation-triangle"></span>
                        <div class="p-message-text">
                            <span class="p-message-summary">Attention</span>
                            <span class="p-message-detail">Veuillez ne pas définir une fréquence trop élevée pour les
                                tâches planifiées afin d'éviter de surcharger le serveur. Utilisez cette fonctionnalité
                                avec parcimonie.</span>
                        </div>
                    </div>
                </div>
                <p-table [value]="jobs()" dataKey="jobId" styleClass="p-datatable-customers" [rowHover]="true"
                    [loading]="loading()">
                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="description">
                                <div class="flex justify-content-between align-items-center">
                                    Description
                                    <p-sortIcon field="description"></p-sortIcon>
                                    <p-columnFilter type="text" field="description" display="menu" class="ml-auto">
                                    </p-columnFilter>
                                </div>
                            </th>
                            <th pSortableColumn="cronExpression">
                                <div class="flex justify-content-between align-items-center">
                                    Fréquence
                                    <p-sortIcon field="cronExpression"></p-sortIcon>
                                </div>
                            </th>
                            <th pSortableColumn="statut">
                                <div class="flex justify-content-between align-items-center">
                                    Statut
                                    <p-sortIcon field="statut"></p-sortIcon>
                                </div>
                            </th>
                            <th pSortableColumn="derniereExecution">
                                <div class="flex justify-content-between align-items-center">
                                    Dernière exécution
                                    <p-sortIcon field="derniereExecution"></p-sortIcon>
                                </div>
                            </th>
                            <th style="width: 15rem">Actions</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-job>
                        <tr class="p-selectable-row">
                            <td [attr.rowspan]="job.erreur ? '2' : '1'">
                                <span class="p-column-title">Description</span>
                                {{ job.description }}
                            </td>
                            <td>
                                <span class="p-column-title">Fréquence</span>
                                <p-chip [label]="ToReadableCron(job.cronExpression)" styleClass="mr-2"
                                    [removable]="false"></p-chip>
                            </td>
                            <td>
                                <span class="p-column-title">Statut</span>
                                <p-tag
                                    [severity]="getStatutSeverity(job.statut)"
                                    [value]="getStatutLabel(job.statut)"
                                    [icon]="job.statut === JobStatut.EnCours ? 'pi pi-spinner pi-spin' : ''">
                                </p-tag>
                            </td>
                            <td>
                                <span class="p-column-title">Dernière exécution</span>
                                {{ job.derniereExecution | date:'dd/MM/yyyy HH:mm:ss':'America/Montreal' }}
                            </td>
                            <td>
                                <div class="flex justify-content-center gap-2">
                                    <p-button icon="pi pi-play-circle" [rounded]="true" [text]="true" severity="info"
                                        pTooltip="Forcer l'exécution" tooltipPosition="top" (onClick)="forceJob(job)"
                                        [disabled]="job.statut === JobStatut.EnCours"></p-button>

                                    <p-button icon="pi pi-pencil" [rounded]="true" [text]="true" severity="warn"
                                        pTooltip="Modifier" tooltipPosition="top" (onClick)="editJob(job)"
                                        [disabled]="job.statut === JobStatut.EnCours"></p-button>

                                    <p-button [rounded]="true" [text]="true"
                                        [severity]="isActif(job) ? 'danger' : 'success'"
                                        [icon]="isActif(job) ? 'pi pi-pause' : 'pi pi-play'"
                                        [pTooltip]="isActif(job) ? 'Désactiver' : 'Activer'"
                                        tooltipPosition="top" [disabled]="job.statut === JobStatut.EnCours"
                                        (onClick)="toggleJobStatus(job)">
                                    </p-button>
                                </div>
                            </td>
                        </tr>
                        @if (job.erreur) {
                            <tr>
                                <td colspan="5">
                                    <span class="p-column-title font-bold">Erreur</span>
                                    <div class="p-error p-2" style="border-left: 4px solid #f44336; padding-left: 8px;">
                                        <i class="pi pi-exclamation-triangle mr-2" style="color: #f44336;"></i>
                                        Cette tâche planifiée a rencontré une erreur lors de sa dernière exécution:
                                        {{ job.erreur }}
                                    </div>
                                </td>
                            </tr>
                        }
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="5">Aucune tâche planifiée trouvée.</td>
                        </tr>
                    </ng-template>
                </p-table>
            }
        </p-card>
    </div>
</div>

<p-dialog [(visible)]="jobDialog" [style]="{width: '600px'}" header="Détails de la tâche planifiée" [modal]="true"
    styleClass="p-fluid" [draggable]="false" [resizable]="false">
    @if (selectedJob) {
        <div class="p-field">
            <div class="flex flex-column gap-2 mb-4">
                <label for="description">Description</label>
                <input type="text" pInputText id="description" [(ngModel)]="selectedJob.description" disabled />
            </div>
            <div class="flex flex-column gap-2 mb-4">
                <label>Statut</label>
                <div class="p-field-checkbox">
                    <p-inputSwitch [ngModel]="selectedJobActif" (ngModelChange)="setSelectedJobActif($event)"></p-inputSwitch>
                    <label class="ml-2">{{ selectedJobActif ? 'Actif' : 'Inactif' }}</label>
                </div>
            </div>
            <div class="overflow-x-auto" style="max-height: 400px;">
                <div class="flex flex-column gap-2 mb-4">
                    <label for="cronExpression">Expression Cron</label>
                    <input type="text" pInputText id="cronExpression" [(ngModel)]="selectedJob.cronExpression" />
                    <small class="text-muted">Format: secondes minutes heures jourDuMois mois jourDeLaSemaine</small>
                </div>
                <div class="flex flex-column gap-2 mb-4">
                    <app-cron-editor [(cronExpression)]="selectedJob.cronExpression"></app-cron-editor>
                </div>
            </div>
        </div>
    }
    <ng-template pTemplate="footer">
        <p-button label="Annuler" icon="pi pi-times" [text]="true" (onClick)="hideDialog()"></p-button>
        <p-button label="Enregistrer" icon="pi pi-check" [text]="true" (onClick)="saveJob()"></p-button>
    </ng-template>
</p-dialog>
